var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "selected-items truncate text-xs" }, [
    _vm.hasNoItems
      ? _c("span", [_vm._v(" " + _vm._s(_vm.defaultText) + " ")])
      : _c("span", [
          _vm._v(" " + _vm._s(_vm.selectedItemsDisplayMessage) + " ")
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }